import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import PendingIcon from "../../assets/icons/PendingYellowIcon.svg";
import RejectIcon from "../../assets/icons/RejectIcon.svg";
import VerifyIcon from "../../assets/icons/VerifyIcon.svg";
import GradientText from "../../commons/components/GradientText/GradientText";
import { MERCHANT_ACOUNT_INFORMATION } from "../../commons/constants/api-urls";
import { MerchantStatusEnum } from "../../commons/constants/user";
import { MoneyReceiveIcon } from "../../commons/resources";
import defaultAxios from "../../commons/utils/axios";
import { mapAccountInformation } from "../../commons/utils/functions/accountInformationMapping";
import { format2Digit, formatLP } from "../../commons/utils/functions/formatPrice";
import { STATUS_CODE } from "../Notification/Notification";
import styles from "./AccountInformation.module.scss";

const AccountInformation: React.FC = () => {
  const [data, setData] = useState<any>();

  useEffect(() => {
    getUserInfo();
  }, []);

  const getUserInfo = async () => {
    try {
      const res = await defaultAxios.get(MERCHANT_ACOUNT_INFORMATION());
      if (res.data && res.status === STATUS_CODE.SUCCESS) {
        setData(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getAccountInformation = useMemo(() => {
    return mapAccountInformation(data);
  }, [data]);

  return (
    <div className={styles.wrapper}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div className={styles.title}>Account information</div>
        {/* <div style={{ width: "200px" }}>
          <PrimaryButton
            children={
              <span
                onClick={() => {
                  navigate(routers.UPDATE_ACCOUNT_INFORMATION);
                }}
              >
                Update Information
              </span>
            }
          />
        </div> */}
        <div className={styles.updateAccountTitle}>
          To update Account Information, please email to{" "}
          <span className={styles.supportLink}>customersupport@tridentity.me</span>
        </div>
      </div>

      <div className={styles.panel}>
        {/* {getAccountInformation.merchantStatus === MerchantStatusEnum.DRAFT && (
          <div className={styles.accountStatus}>
            <img src={PendingIcon} alt="icon" />
            <GradientText text={"Your account need approve from admin to go live"} />
          </div>
        )}

        {status === "PENDING" && getAccountInformation.merchantStatus !== MerchantStatusEnum.DRAFT && (
          <div className={styles.accountStatus}>
            <img src={PendingIcon} alt="icon" />
            <GradientText text={"Your account is in the process of being approved"} />
          </div>
        )}
        {status === "REJECTED" && getAccountInformation.merchantStatus !== MerchantStatusEnum.DRAFT && (
          <div className={styles.accountStatus}>
            <img src={RejectIcon} alt="icon" />
            <p>
              Your updates could not be processed. Please correct the information within 72 hours or your update will be
              reset
            </p>
          </div>
        )}
        {status === "ACCEPTED" && getAccountInformation.merchantStatus !== MerchantStatusEnum.DRAFT && (
          <div className={styles.accountStatus}>
            <img src={VerifyIcon} alt="icon" />
            <p className={styles.verified}>Your account have been verified.</p>
          </div>
        )} */}
        <div className={styles.summary}>
          <div className={styles.iconWRapper}>
            <MoneyReceiveIcon />
          </div>
          <div className={styles.info}>
            <div className={styles.label}>Total Revenue</div>
            <div className={styles.row}>
              <div className={styles.name}>
                <GradientText text="TOTAL FIAT:" />
              </div>
              <div className={styles.value}>
                <GradientText text={`S$ ${format2Digit(data?.reports?.total_revenue)}`} />
              </div>
            </div>
            <div className={styles.row}>
              {/* <div className={styles.name}>
                <GradientText text="TOTAL LP:" />
              </div> */}
              <div className={styles.value}>
                <GradientText text={`${formatLP(data?.reports?.total_received_lp)}`} />
              </div>
            </div>
          </div>
        </div>
        <h2 className={styles.infoTitle}>Account Information</h2>
        <div className={styles.detail}>
          <div className={styles.column}>
            {getAccountInformation.arrayAccountInformation.slice(0, 2).map((item, index) => {
              return (
                <div className={styles.row} key={index}>
                  <div className={styles.label}>{item.title}</div>
                  <div className={styles.value}>{item.value}</div>
                  {item.isReject && (
                    <div className={styles.rejectMessage}>The information you entered is not valid</div>
                  )}
                </div>
              );
            })}
          </div>
          <div className={[styles.column, styles.secondColumn].join(" ")}>
            {getAccountInformation.arrayAccountInformation.slice(2).map((item, index) => {
              return (
                <div className={styles.row} key={index}>
                  <div className={styles.label}>{item.title}</div>
                  <div className={styles.value}>{item.value}</div>
                  {item.isReject && (
                    <div className={styles.rejectMessage}>The information you entered is not valid</div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
        <h2 className={styles.infoTitle}>Merchant Information</h2>
        <div className={styles.detail}>
          <div className={styles.column}>
            {getAccountInformation.arrayMerchantInformation.slice(0, 4).map((item, index) => {
              return (
                <div className={styles.row} key={index}>
                  <div className={styles.label}>{item.title}</div>
                  <div className={styles.value}>{item.value}</div>
                  {item.isReject && (
                    <div className={styles.rejectMessage}>The information you entered is not valid</div>
                  )}
                </div>
              );
            })}
          </div>
          <div className={[styles.column, styles.secondColumn].join(" ")}>
            {getAccountInformation.arrayMerchantInformation.slice(4).map((item, index) => {
              return (
                <div className={styles.row} key={index}>
                  <div className={styles.label}>{item.title}</div>
                  <div className={styles.value}>{item.value}</div>
                  {item.isReject && (
                    <div className={styles.rejectMessage}>The information you entered is not valid</div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
        <h2 className={styles.infoTitle}>Payment Details</h2>
        <div className={styles.detail}>
          <div className={styles.column}>
            {getAccountInformation.arrayPaymentDetails.slice(0, 4).map((item, index) => {
              return (
                <div className={styles.row} key={index}>
                  <div className={styles.label}>{item.title}</div>
                  <div className={styles.value}>{item.value}</div>
                  {item.isReject && (
                    <div className={styles.rejectMessage}>The information you entered is not valid</div>
                  )}
                </div>
              );
            })}
          </div>
          <div className={[styles.column, styles.secondColumn].join(" ")}>
            {getAccountInformation.arrayPaymentDetails.slice(4).map((item, index) => {
              return (
                <div className={styles.row} key={index}>
                  <div className={styles.label}>{item.title}</div>
                  <div className={styles.value}>{item.value}</div>
                  {item.isReject && (
                    <div className={styles.rejectMessage}>The information you entered is not valid</div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* <div className={styles.detail}>
          <div className={styles.column}>
            <div className={styles.row}>
              <div className={styles.label}>Documentation</div>
              <div className={styles.documents}>
                {(data?.information?.merchantApprovals?.documents as any[])?.length > 0
                  ? (data?.information?.merchantApprovals?.documents as any[])?.map((item, index) => {
                      return (
                        <a key={index} href={item} target="_blank" rel="noreferrer">
                          <div className={styles.document} key={index}>
                            <DocumentTextIcon />
                            {last(item.split("/"))}
                          </div>
                          {item.isReject && (
                            <div className={styles.rejectMessage}>The information you entered is not valid</div>
                          )}
                        </a>
                      );
                    })
                  : (data?.information?.documents as any[])?.map((item, index) => {
                      return (
                        <a key={index} href={item} target="_blank" rel="noreferrer">
                          <div className={styles.document} key={index}>
                            <DocumentTextIcon />
                            {last(item.split("/"))}
                          </div>
                          {item.isReject && (
                            <div className={styles.rejectMessage}>The information you entered is not valid</div>
                          )}
                        </a>
                      );
                    })}
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default AccountInformation;
